import hs from './highslide-settings';

export default (props, e) => {
  e.preventDefault();
  const href = e.target.closest('a');
  hs.expand(href, {
    wrapperClassName: 'imageContent',
    slideshowGroup: 1,
  });
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/webActions/hsExpand/index.js